import { inject } from 'vue';
import { useDefaultDataLayer } from '../useDataLayer';
import type { DataLayerEvent } from '../useDataLayer';

export interface UseAccordionTrackingOptions {
  componentName?: string;
  linkText?: string;
  location?: string;
}

export interface UseAccordionTrackingReturn {
  trackAccordionState: (isOpen: boolean, additionalData?: DataLayerEvent) => void;
}

export function useAccordionTracking(
  options: UseAccordionTrackingOptions = {}
): UseAccordionTrackingReturn {
  const { componentName, linkText = '', location = '' } = options;
  const { registerInteraction } = useDefaultDataLayer();

  const dataLayerParentProps = inject<Record<string, unknown>>('dataLayerParentProps', {});

  const trackAccordionState = (isOpen: boolean, additionalData: DataLayerEvent = {}) => {
    const eventName = isOpen ? 'accordion_open' : 'accordion_collapse';

    registerInteraction({
      event: eventName,
      link_text: linkText?.toLowerCase() || '',
      component: componentName || dataLayerParentProps?.accordionComponentName || 'Accordion',
      intent: 'accordion_interaction',
      event_location: location || dataLayerParentProps?.accordionLocation || 'body',
      ...additionalData,
    });
  };

  return {
    trackAccordionState,
  };
}
